// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"5a33fa1a","239":"63205fe5","555":"2d88c607","781":"ce5539fc","822":"b690dc94","999":"3300227a"}[chunkId] + ".chunk.css";
};